import Model from "./Model";

export default class Payment extends Model{
    resource(){
        return 'payment'
    }
    get payment_date_for_humans(){
        if(!this.payment_date){
            return null
        }
        const date = new Date(this.payment_date)
        const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
        return `${date.getDate()} de ${months[date.getMonth()]} del ${date.getFullYear()}`
    }
}